import ToolTip from "../../ToolTip/ToolTip";

export const SME_TOPIC_SCHEDULES_HEAD = [
  { field: "sl_no", headerName: "Sl No", width: 100 },
  // { field: "lead_name", headerName: "Student Name", width: 200 },
  // { field: "lead_mob_no", headerName: "Phone Number", width: 200 },
  { field: "subject_name", headerName: "Subject", width: 200 },
  { field: "session_no", headerName: "Session Number", width: 150 },
  {
    field: "chapter",
    headerName: "Chapter",
    width: 250,
    renderCell: (params) => {
      return (
        <ToolTip expand={params.row.chapter} content={params.row.chapter} />
      );
    },
  },
  {
    field: "topic",
    headerName: "Topic",
    width: 250,
    renderCell: (params) => {
      return <ToolTip expand={params.row.topic} content={params.row.topic} />;
    },
  },
  {
    field: "objectives",
    headerName: "Objectives",
    width: 250,
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.objectives}
          content={params.row.objectives}
        />
      );
    },
  },
];
